import React from 'react';
import { InputGroup, InputGroupAddon } from 'reactstrap';
import { BasicText, asField } from 'informed';
import classnames from 'classnames';

export default asField(({
  fieldState, field, label, helpBlock, numbers, col, required, leftAddon, rightAddon, ...props
}) => (
   <div className={classnames('form-group', col, { required, 'has-error': fieldState.error })}>
    {
      label ?
      <label style={{color:'#453166', fontWeight:500,marginBottom:'4px', fontFamily:'Public Sans',fontSize:'14px'
      }}>{label}</label> :
      <label />
    }
    <InputGroup className={`form-input ${label ? '' : 'no-label'}`}>
      {leftAddon && <InputGroupAddon addonType="prepend" className="addon-left"> {leftAddon} </InputGroupAddon>}
      <BasicText
        className="form-control"
        fieldState={fieldState}
        id={field}
        {...props}
      />
      {rightAddon && <InputGroupAddon addonType="append" className="addon-right"> {rightAddon} </InputGroupAddon>}
    </InputGroup>
    {fieldState.error && <small className={fieldState.error ? 'text-danger' : null}>{fieldState.error}</small>}
  </div>
));
